module.exports = __webpack_public_path__ + "img/nebulosas.6b60207a.jpg";